import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import logo4 from './logo4.png';
import './Navbar.css'

const Navbar = ({ logoutUser }) => {
  const { isLoggedIn, user } = useSelector(
    (state) => ({
      isLoggedIn: state.auth.isLoggedIn,
      user: state.auth.user,
    }),
    shallowEqual
  );
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  return (
    <nav className="navbar navbar-expand-lg shadow" style={{backgroundColor: "#FFFFFF"}}>
      <Link to="/admin/dashboard/posts" className="nav-link"><img
        className="img mt-2" height={"64px"}
        src={logo4}
      /></Link>
      
      <ul className="navbar-nav">
        {/* <li className="nav-item">
        <Link to="/admin/dashboard/" className="navbar-brand ml-4 text-dark" style={{font: "SF Pro Text",marginRight: "0.4rem"}}>
        Admin Dashboard
      </Link>
        </li> */}
        {/* <li className="nav-item">
          <NavLink exact to="/admin/dashboard" className="nav-link ml-4 text-dark" style={{font: "SF Pro Text"}}>
            Home
          </NavLink>
        </li> */}
        <li className="nav-item">
          {/* <Link className={`${path === "/admin/dashboard/posts" ? "mm-active" : "dashboard"}`} to="/admin/dashboard/posts"> All Ads</Link> */}
          <NavLink exact to="/admin/dashboard/posts" className="nav-link" style={{font: "SF Pro Text", fontWeight: "500",paddingTop:"0.6rem", marginLeft: "90px", borderRadius: "100px"}}>
            All Ads
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact to="/admin/dashboard/addPost" className="nav-link" style={{font: "SF Pro Text", fontWeight: "500", marginRight: "0.1rem" ,paddingTop: "0.6rem", paddingLeft: "10px", borderRadius: "100px", marginLeft: "7px"}}>
            Create Ad
          </NavLink>
        </li>
      </ul>
      {isLoggedIn && (
        <div className="profile text-dark ml-auto mr-5 mt-2">
          {/* Welcome Admin{" "} */}
          <span className="text-warning">{user.displayName}</span>
          <button className="btn ml-3" onClick={() => logoutUser()} style={{backgroundColor: "#1AC5D9", borderRadius: "100px",color: "white", paddingTop: "0.4rem",paddingBottom: "0.5rem", paddingLeft: "1rem", paddingRight: "1rem", fontSize: "20px"}}>
            Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
